import { render } from "./VerificationPage.vue?vue&type=template&id=557ab322&scoped=true"
import script from "./VerificationPage.vue?vue&type=script&lang=js"
export * from "./VerificationPage.vue?vue&type=script&lang=js"

import "./VerificationPage.vue?vue&type=style&index=0&id=557ab322&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557ab322"]])

export default __exports__